/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable max-len */
const React = require('react');
const PropTypes = require('prop-types');
const Card = require('@andes/card');
const { CardContent } = require('@andes/card');
const { Link } = require('frontend-spa');
const Message = require('@andes/message');
const MenuUtils = require('../../../../utils/menu');
const { sanitizePath } = require('../../../common/URLSanitizer');
const OnlinePayments = require('./images/OverViewOnlinePayments');
const InPersonPayments = require('./images/OverViewPersonPayments');
const Plugins = require('./images/OverViewPlugins');
const AnchoredMenu = require('../../AnchoredMenu');
const FeedbackThumbs = require('../../FeedbackThumbs');
const { getEventTracker } = require('../../../../utils/event-tracker');

function OverView(props) {
  const { i18n, lang, platform, deviceType, setActiveItem, actualUrl, cookieFeedback } = props;

  const callbackUrl = `https://www.${platform.domain}/developers/${lang}/guides/overview`;
  const isMobile = deviceType === 'mobile';
  const Tracker = getEventTracker();

  return (
    <div className="overview-layout-container">
      <div className="overview-container">
        <div className="right-sidebar">
          {
            !isMobile
            && <FeedbackThumbs
              i18n={i18n}
              actualLocation={actualUrl.href}
              lang={lang}
              siteId={platform.siteId}
              domain={platform.domain}
              cookieFeedback={cookieFeedback}
              asideFormat
            />
          }
          {(deviceType !== 'mobile') && (
            <AnchoredMenu contentSelectorClass=".overview-container" />
          )}
        </div>
        <div className="overview-title">
          <div className="overview-title__text">
            <h1>{`${i18n.gettext('Empieza por aquí')}`}</h1>
            <p>{`${i18n.gettext('Mercado Pago ofrece varias soluciones de pago que te permiten recibir pagos online o de forma presencial en tu tienda')}`}. {`${i18n.gettext('Puedes ofrecer a tus clientes métodos de pago, sin contratos ni cuotas mensuales, mediante integraciones en tu tienda online o mediante productos como Link de pago, Código QR y Point, que pueden estar o no integrados entre sí')}.`}<br /><br />
              {`${i18n.gettext('El flujo de integración a tu tienda es siempre el mismo')}`}. {`${i18n.gettext('El primer paso para integrar Mercado Pago es tener una cuenta de Mercado Pago, ya que es en esta aquí donde recibirás los pagos de ventas y tendrás acceso a tus credenciales de integración')}.`}
            </p>
          </div>
        </div>
        <div className="overview-card-note">
          <Card paddingSize={24}>
            <CardContent>
              <p>{`${i18n.gettext('Si ya tienes una cuenta de Mercado Libre, simplemente accede a')}`} <a className="overview-link" onClick={() => { Tracker.send('mpdevelopers/click_overview_mphome'); }} href={`https://www.${platform.domain}/home`} target="_blank">{`${i18n.gettext('Mercado Pago')}`} </a>{i18n.gettext('con el mismo usuario y contraseña')}.</p>
            </CardContent>
          </Card>
        </div>
        <div className="overview-text">
          <p>{`${i18n.gettext('Con tu cuenta de Mercado Pago, puedes integrar nuestros productos a tu tienda de dos formas')}:`}</p>
          <ul className="overview-bullet">
            <li>{`${i18n.gettext('Instala plugins de forma sencilla')}`}</li>
            <li>{`${i18n.gettext('Desarrolla código')}`}</li>
          </ul>
        </div>
        <div className="overview-message">
          <Message color="orange" hierarchy="quiet" title={i18n.gettext('Importante')}>
            <div>
              <p>{`${i18n.gettext('Si no eres desarrollador, te recomendamos que integres nuestras soluciones de pago a través de plugins')}.`}</p>
            </div>
          </Message>
        </div>
        <div className="overview-text-container">
          <div className="overview-text">
            <h2 id="bookmark_instala_los_plugins">{`${i18n.gettext('Instala los Plugins')}`}</h2>
            <div className="overview-enum">
              <p>{`${i18n.gettext('Los plugins son componentes sin necesidad de desarrollo que agregan funcionalidades específicas a un sistema')}`}. {`${i18n.gettext('En nuestro caso, los plugins realizan la instalación de determinadas soluciones de Mercado Pago a la tienda creada en algunas de las plataformas de e-commerce más conocidas sin necesidad de desarrollar código')}.`}
              </p>
              <ol>
                <li><a className="overview-link" onClick={() => { Tracker.send('mpdevelopers/click_overview_create_account'); }} href={`https://registration.${platform.domain}/registration-mp?confirmation_url=${callbackUrl}`}> {`${`${i18n.gettext('Crea una cuenta de Mercado Pago')}`}`}</a>.</li>
                <li>{`${i18n.gettext('En Mercado Pago, accede al menú')}`} <a className="overview-link" onClick={() => { Tracker.send('mpdevelopers/click_overview_credentials'); }} href={`https://www.${platform.domain}/settings/account/credentials`}>{`${i18n.gettext('Su negocio > Configuración > Gestión y administración > Credenciales')}`}</a>.</li>
                <li>{`${i18n.gettext('Crea una aplicación y elige el plugin a instalar según la plataforma en la que se desarrolló tu tienda')}`}.</li>
                <li><a className="overview-link" onClick={() => { Tracker.send('mpdevelopers/click_overview_credentials'); }} href={`/developers/${lang}/guides/resources/credentials`}> {`${`${i18n.gettext('Accede a tus credenciales')}`}`}</a>.</li>
                <li><a className="overview-link" onClick={() => { Tracker.send('mpdevelopers/click_overview_landing_plugins'); }} href={`/developers/${lang}/guides/plugins`}> {`${`${i18n.gettext('Instala el plugin deseado consultando nuestros manuales')}`}`}</a>.</li>
              </ol>
            </div>
          </div>
          <div className="overview-card-container">
            <Card className="overview-card" paddingSize={24} animated>
              <CardContent className="overview-card-content">
                <Link
                  to={`/developers/${lang}/guides/plugins/`}
                  onClick={() => { Tracker.send('mpdevelopers/click_overview_landing_plugins'); setActiveItem(MenuUtils.getItemFromURLParent(sanitizePath(`/developers/${lang}/guides/plugins`), platform.siteId.toLowerCase(), lang)); }}
                >
                  <Plugins />
                  <h3>{`${i18n.gettext('Plugins y plataformas')}`}</h3>
                  <p>{`${i18n.gettext('Acepta pagos en Shopify, WooCommerce, Prestashop y otras plataformas de ecommerce.')}`}</p>
                </Link>
              </CardContent>
            </Card>
          </div>
          <div className="overview-message">
            <Message color="accent" hierarchy="quiet" title={i18n.gettext('Nota')}>
              <div>
                <p>{`${i18n.gettext('Si eres un desarrollador, puedes crear una solución que incluya la instalación de un plugin')}`}. {`${i18n.gettext('Simplemente sigue los pasos de integrar de la aplicación e instala el plugin para la aplicación creada')}.`}
                </p>
              </div>
            </Message>
          </div>
          <div className="overview-text">
            <h2 id="bookmark_el_desarrollo_con_código">{`${i18n.gettext('Desarrolla con código')}`}</h2>
            <div className="overview-enum">
              <p>{`${i18n.gettext('Las soluciones se crean y gestionan a través del')}`} <a className="overview-link" onClick={() => { Tracker.send('mpdevelopers/click_overview_dev_panel'); }} href="/developers/panel/app">{`${i18n.gettext('Dashboard')}`}</a>. {`${i18n.gettext('Consulta a continuación los pasos para desarrollar soluciones a través de código')}.`}
              </p>
              <ol>
                <li><a className="overview-link" onClick={() => { Tracker.send('mpdevelopers/click_overview_create_account'); }} href={`https://registration.${platform.domain}/registration-mp?confirmation_url=${callbackUrl}`}>{`${i18n.gettext('Crea una cuenta de Mercado Pago')}`}</a>: {`${i18n.gettext('necesitas una cuenta para integrar nuestras soluciones de pago')}.`}</li>
                <li>{`${i18n.gettext('Crea una aplicación a través del')}`} <a className="overview-link" onClick={() => { Tracker.send('mpdevelopers/click_overview_dev_panel'); }} href="/developers/panel/app">{`${i18n.gettext('Dashboard')}`}</a>: {`${i18n.gettext('puedes configurar cada una, eligiendo la solución a integrar como desees, teniendo en cuenta las necesidades del negocio y consultando nuestros manuales')}`}.</li>
                <li><a className="overview-link" onClick={() => { Tracker.send('mpdevelopers/click_overview_credentials'); }} href={`/developers/${lang}/guides/resources/credentials`}> {`${`${i18n.gettext('Accede a tus credenciales')}`}`}</a>: {`${i18n.gettext('las credenciales son contraseñas únicas que te permiten identificar y conectar tu cuenta de Mercado Pago en una integración')}. `} {`${i18n.gettext('Sirven para capturar pagos en tiendas online y otras aplicaciones de forma segura')}`}.</li>
                <li>{`${i18n.gettext('Realiza pruebas')}:`} {`${i18n.gettext('te recomendamos que siempre pruebes la integración antes de entrar en producción')}. `} {`${i18n.gettext('Dependiendo del producto que estés implementando, puedes usar credenciales de prueba en sandbox o usar usuarios de prueba en entornos productivos')}. `} {`${i18n.gettext('Consulta el manual de cada producto para obtener más información sobre las opciones disponibles')}`}.</li>
                <li>{`${i18n.gettext('Sal a producción')}:`} {`${i18n.gettext('si todo funciona correctamente, puedes salir a producción')}. `} {`${i18n.gettext('Recuerda verificar antes los')}`}<a className="overview-link" onClick={() => { Tracker.send('mpdevelopers/click_overview_requirements'); }} href={`/developers/${lang}/guides/manage-account/account/go-live-requirements`}> {`${`${i18n.gettext('requisitos para salir en producción')}`}`}</a>.</li>
              </ol>
            </div>
          </div>
        </div>
        <div className="overview-card-container">
          <Card className="overview-card" paddingSize={24} animated>
            <CardContent className="overview-card-content">
              <Link
                to={`/developers/${lang}/guides/online-payments/`}
                onClick={() => { Tracker.send('mpdevelopers/click_overview_landing_op'); setActiveItem(MenuUtils.getItemFromURLParent(sanitizePath(`/developers/${lang}/guides/online-payments`), platform.siteId.toLowerCase(), lang)); }}
              >
                <OnlinePayments />
                <h3>{`${i18n.gettext('Cobros online')}`}</h3>
                <p>{`${i18n.gettext('Usa nuestros checkouts o la API de pagos para cobrar en redes sociales, sitios web y otras aplicaciones.')}`}</p>
              </Link>
            </CardContent>
          </Card>
          <Card className="overview-card" paddingSize={24} animated>
            <CardContent className="overview-card-content">
              <Link
                to={`/developers/${lang}/guides/in-person-payments/`}
                onClick={() => { Tracker.send('mpdevelopers/click_overview_landing_ipp'); setActiveItem(MenuUtils.getItemFromURLParent(sanitizePath(`/developers/${lang}/guides/in-person-payments`), platform.siteId.toLowerCase(), lang)); }}
              >
                <InPersonPayments />
                <h3>{`${i18n.gettext('Pagos presenciales')}`}</h3>
                <p>{`${i18n.gettext('Ofrece pagos en puntos de venta, con todas las tarjetas y dispositivos móviles.')}`}</p>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}

OverView.propTypes = {
  i18n: PropTypes.shape({
    gettext: PropTypes.func.isRequired,
  }),
  platform: PropTypes.shape({
    siteId: PropTypes.string,
    domain: PropTypes.string,
  }).isRequired,
  lang: PropTypes.string.isRequired,
  setActiveItem: PropTypes.func.isRequired,
};

OverView.defaultProps = {
  i18n: { gettext: () => { } },
};

module.exports = OverView;
